import { FEATURE_FLAGS } from '~/constants';
import { useFeature } from '~/hooks/useFeatureFlag/useFeature';

const OldSkeletonCard = () => (
  <div className="pointer-events-none flex min-w-[300px] flex-col gap-[10px] rounded-12 border border-card-border-color-default bg-card-background-color-default p-6">
    <div className="h-3 w-[132px] animate-pulse rounded-4 bg-neutral-50" />
    <div className="h-10 w-[84px] animate-pulse rounded-4 bg-neutral-50" />
  </div>
);

const NewSkeletonCard = () => (
  <div className="pointer-events-none flex flex-col gap-1 rounded-12 border border-card-border-color-default bg-card-background-color-default px-4 py-3">
    <div className="flex items-center justify-between">
      <div className="h-4 w-32 animate-pulse rounded-4 bg-neutral-50" />
      <div className="h-4 w-16 animate-pulse rounded-4 bg-neutral-50" />
    </div>
    <div className="h-3 w-24 animate-pulse rounded-4 bg-neutral-50" />
  </div>
);

export const SkeletonCard = () => {
  const isMetricsCardsEnabled = useFeature(
    FEATURE_FLAGS.foamMetricsCards,
  ).isEnabled;

  return isMetricsCardsEnabled ? <NewSkeletonCard /> : <OldSkeletonCard />;
};
